<template>
  <div>
    <loadingCube v-if="loading"/>

    <div v-if="!loading">
      <PageHeading v-if="site"
          :back="this.back"
      >
        <template #title>
          <span>
              {{ company?.company_name }}
          </span>
          <br/>
          <router-link :to="{ name: 'c_timesheet_r2_select_sites', params: { company_id, start_date, end_date } }">
            Submit Sites
          </router-link>
          <router-link
              :to="{ name: 'c_timesheet_r2_select_site_worker', params: { company_id, start_date, end_date } }">
            -> Submit Timesheets
          </router-link>
          -> Assign worker
        </template>
        <template>
          <h2>{{ site.address }}</h2>
          <p>
            Selected Timesheet period: {{ dateFormat(start_date) }} - {{ dateFormat(end_date) }}.
            <router-link :to="{ name: 'c_timesheet_r2_select_period', params: { company_id }}">(change)</router-link>
          </p>


        </template>
      </PageHeading>

      <div class="pane" style="display: grid; grid-template-columns: 100%;">
        <div>
        Assign a worker to the following site:<br>
          <strong>{{ site?.address }}</strong>
        <hr>
      </div>

        <div v-if="noAssignableJobTitles" class="alert alert-warning">
          <strong>This order has ended. Workers cannot be assigned.</strong>
          <div class="mt-2">
            <router-link :to="back">Back to timesheets</router-link>
          </div>
        </div>

        <ValidationObserver v-else ref="assignWorkerForm" slim>
          <form autocomplete="off" role="form" @submit.prevent="submit_assign_worker">
            <p>Search for the worker you wish to assign.</p>


            <ValidationProvider v-slot="{errors, classes}" class="col-12 form-group" name="Worker" rules="required"
                tag="div">
              <label class="form-label" for="worker">Worker to Assign</label>
              <multiselect id="worker" v-model="worker" :class="classes" :custom-label="worker_name_label"
                  :options="ms_opts.workers"
                  :show-labels="false"
                  class="requiredField" name="worker" placeholder="" track-by="id">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span
                        class="option__title">{{ props.option.person.first_name }} {{ props.option.person.surname }}</span>
                    <span class="option__small" style="float: right;">({{ getReferenceNumber(props.option) }})</span>
                  </div>
                </template>
              </multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- The following only shows up once a worker has been selected -->
            <!-- Multiselect - Job Title for worker -->
            <ValidationProvider v-if="worker !== null" v-slot="{errors, classes}" class="col-12 form-group"
                name="Job Title"
                rules="required"
                tag="div">
              <label class="form-label"
                  for="job_title">Job title on site for {{ worker.person.first_name }} {{ worker.person.surname }}</label>
              <multiselect id="job_title" v-model="job_title" :class="classes" :options="ms_opts.job_titles"
                  class="requiredField"
                  label="job_title"
                  name="job_title" placeholder="" track-by="id" @select="selectJobTitle">
              </multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>

            <!-- The following only shows up once a job title has been selected -->
            <template v-if="job_title !== null">
              <div>
                <p>
                  Select from the available rates for this job title on this site.<br>
                If the rate does not exist you can add it as a new rate.</p>
            </div>

                <!-- Multiselect to choose from existing rates on order_job -->
                <ValidationProvider v-if="ms_opts.existing_rates.length > 0 && !add_new_rate"
                  v-slot="{errors, classes}" class="col-12 form-group" name="Pay Rate" rules="required" tag="div">
                <label class="form-label"
                    for="pay_rate">Rate for {{ worker.person.first_name }} {{ worker.person.surname }}</label>
                <multiselect id="pay_rate" v-model="existing_rate" :class="classes"
                    :custom-label="existing_rate_label"
                    :options="ms_opts.existing_rates" :show-labels="false"
                    class="requiredField" name="pay_rate" placeholder=""
                    track-by="id">
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">£ {{ props.option.pay_amount }}</span>
                        <span class="option__small" style="float: right;">({{ props.option.pay_type }})</span>
                      </div>
                    </template>
                  <span slot="noResult" slot-scope="props" class="noResult"
                      @click.prevent="ms_add_new_rate(props.search)">ADD NEW RATE</span>
                  </multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              <template v-if="add_new_rate">
                    <!-- If add_rate because the rate does not already exist on the order_job -->
                    <!-- Pay Type -->
                <ValidationProvider v-slot="{errors, classes}" class="col-6 form-group" name="Pay Type"
                    rules="required"
                    tag="div">
                      <label class="form-label" for="pay_type">Pay Type</label>
                  <multiselect id="pay_type" v-model="new_rate.pay_type" :class="classes"
                      :options="ms_opts.pay_types" :show-labels="false" class="requiredField"
                      label="value" name="pay_type" placeholder=""
                      track-by="id" @input="rate_calc_recruitment_margin(new_rate)"
                      @select="check_rate_exists"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Pay Amount -->
                <ValidationProvider v-slot="{errors, classes}" class="col-6 form-group" name="Pay Amount"
                    rules="decimal|required"
                    tag="div">
                      <label class="form-label" for="pay_amount">Pay Amount</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                    <input id="pay_amount" v-model="new_rate.pay_amount"
                        :class="[classes, pay_amount_disabled ? 'disabled' : '']" :disabled="pay_amount_disabled"
                        class="form-input requiredField" name="pay_amount"
                        type="text"
                        @input="rate_calc_recruitment_margin(new_rate)" @blur.prevent="check_rate_exists()">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
              </template>

            </template>

            <div v-if="check_all_form_details" class="col-6 offset-6">
              <button :disabled="saving" class="btn orcaBtn" type="submit">
                <span v-if="!saving">Assign Worker</span>
                <span v-else-if="saving"><i class="fas fa-spinner fa-spin"></i> Assigning Worker...</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {calculateRate} from 'utils/utils';
import loadingCube from "loaders/record_loader.vue";
import PageHeading from "pages/sunset/timesheets/components/shared/PageHeading.vue";
import {dateFormat} from '../components/shared';

export default {
  name: "t2_assignworker",
  components: {PageHeading, loadingCube, Multiselect},
  props: {
    company_id: {required: true},
    start_date: {required: true},
    end_date: {required: true},
    order_id: {
      required: true
    },
    order_job_id: {
      required: true
    },
  },
  data() {
    return {
      back: null,
      contact_id: this.$store.state.auth.me.contact_id,
      site: null,
      location: null,
      company: null,
      ms_opts: {
        workers: [],
        job_titles: [],
        existing_rates: [],
        pay_types: this.$store.state.crm_options.pay_type,
      },

      timesheet_order_jobs: null,

      worker: null,
      job_title: null,
      order_types: [],
      order_jobs: [],

      add_new_rate: false,
      existing_rate: null,
      new_rate: {
        type: {value: 'Basic', id: 15},
        pay_type: null,
        pay_amount: '',
        admin_fee_type: '',
        admin_fee: '',
        retention_percentage: '5',
      },
      pay_amount_disabled: false,

      loading: false,
      saving: false,
      noAssignableJobTitles: false,

    }
  },
  async beforeMount() {
    this.loading = true;
    this.back = { name: 'c_timesheet_r2_select_site_worker', params: { company_id: this.company_id, start_date: this.start_date, end_date: this.end_date, order_id: this.order_id, order_job_id: this.order_job_id } };
    await this.fetchSite();
    await this.fetchLocation();
    await this.fetchSupportingData();
    await this.fetchOrderJobs();

    //need fetch order jobs VV
    await this.getOrderJobTitles();
    await this.getAssignmentWorkerList();
    this.loading = false;
  },
  computed: {
    check_all_form_details() {
      if (this.noAssignableJobTitles) {
        return false;
      }
      if (this.worker !== null && this.job_title !== null) {
        if (this.add_new_rate && this.new_rate.pay_type !== null && this.new_rate.pay_amount !== '') {
          return true
        }
        else return !this.add_new_rate && this.existing_rate !== null;
      }
      else {
        return false;
      }
    },
  },
  methods: {
    dateFormat,
    async fetchSupportingData() {
      const result = await axios.get(this.crmApiPath + 'company/' + this.company_id);
      if (result.status !== 200) {
        console.error('Could not fetch company');
        return;
      }
      this.company = result.data;
    },
    async fetchSite() {
      const result = await axios.get(`${this.crmApiPath}r3/client/timesheets/company/${this.company_id}/sites/${this.order_id}/${this.order_job_id}?submission_date=${this.end_date}`);
      if (result.status !== 200) {
        console.error('Could not fetch site');
        return;
      }
      this.site = result.data.data;
    },

    async fetchLocation() {
      try{
        const result = await axios.get(`${this.crmApiPath}timesheet_authorisation/client/location/${this.contact_id}?ts_submission_date=${this.end_date}&location_name=${this.site.address}`)
        if (result.status !== 200) {
          console.error('Could not fetch location');
          return;
        }
        this.location = result.data;
      }
      catch (error){
        console.error('Could not fetch location');
      }
    },

    async fetchOrderJobs() {
      if(!this.location?.order_jobs){
        console.error('No order jobs');
        return;
      }

      let ids = this.location.order_jobs.map(obj => obj.id);
      const result = await axios.get(`${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/legacy_get_order_jobs_by_id`, {params: {ids}});
      if (result.status !== 200) {
        console.error('Could not fetch location');
        return;
      }
      this.order_jobs = result.data;

      for (let job of this.order_jobs) {
        this.order_types.push(job.order.order_type);
      }
    },


    /***********************************************************************
     *  Worker
     ***********************************************************************/

    async getAssignmentWorkerList() {
      let params = {
        order_job_ids: []
      };

      if (!this.location?.order_jobs) {
        console.error('No order jobs so no assignments');
        return;
      }

      if (this.location?.order_jobs) {
        let ids = this.location.order_jobs.map(obj => obj.id);

        params = {
          order_job_ids: [...ids]
        };
        }

      let r = await axios.get(this.crmApiPath + 'assignments/company/assignment_worker_list/' + this.company_id, {
        params
      });

      if (r.status !== 200) {
        console.error('failed to get assignment worker list');
        return;
      }

      let assignments = r.data;

          // map worker employment type to an order type
      let wMapper = {
        'PAYE': 'PAYE',
        'Temporary (PAYE)': 'PAYE',
        'Self Employed (CIS) - Sole Trader': 'Contract',
        'Self Employed - Sole Trader': 'Contract',
        'Limited Company': 'Contract'
      };

      // map order type to employment types
      let oMapper = {
        'Contract': ['Contract'],
        'Internal': ['N/A'],
        'Payroll - Contract': ['Contract'],
        'Payroll - PAYE': ['PAYE'],
        'Permanent': ['Contract', 'PAYE'],
        'Temporary (PAYE)': ['PAYE']
      };

      assignments.forEach((worker) => {
        let workerType = wMapper[worker.rel_company_info.employment_type.value] ?? 'N/A';
        let orderTypes = [];
        this.order_types.forEach(type => {
          let mapped = oMapper[type] ?? [];
          orderTypes.push(...mapped);
        });

        if (orderTypes.includes(workerType)) {
          this.ms_opts.workers.push(worker);
        }
      });
    },

    worker_name_label({person}) {
      return `${person.first_name} ${person.surname}`;
    },

    getReferenceNumber(worker) {
      // check employment status of worker and if they have a company ref number
      // (if limited company use company_internal_finance_ref)
      if (worker.rel_company_info.employment_type_id === 32 && worker.rel_company_info.company_internal_finance_ref !== null) {
        return `${worker.rel_company_info.company_internal_finance_ref}`
      }
      // if not limited company use worker_internal_finance_ref
      return `${worker.internal_finance_ref}`
    },

    /***********************************************************************
     *  Job Titles
     ***********************************************************************/

    async getOrderJobTitles() {
      if (!this.location?.order_jobs) {
        console.error('No order jobs so no job titles');
        return;
      }

      let params = {
        order_job_ids: []
      };
      if (this.location?.order_jobs) {
        let ids = this.location.order_jobs.map(obj => obj.id);

        params = {
          order_job_ids: [...ids]
        };
      }

      let job_titles = await axios.get(this.crmApiPath + 'order/position/get_order_job_titles', {
        params
      });

      this.ms_opts.job_titles = job_titles.data;
      this.noAssignableJobTitles = !job_titles.data.length;
    },

    selectJobTitle() {
      this.$nextTick(() => {
        this.add_new_rate = false;
        this.ms_opts.existing_rates = [];
        this.existing_rate = null;
        this.new_rate = {
          type: {value: 'Basic', id: 15},
          pay_type: null,
          pay_amount: '',
          admin_fee_type: '',
          admin_fee: '',
          retention_percentage: '5',
        };
        this.pay_amount_disabled = false;
        if (this.job_title !== null) {
          this.get_order_position_rates(this.job_title.order_job_id)
        }
      })
    },

    /***********************************************************************
     *  Rates
     ***********************************************************************/

    get_order_position_rates(order_job_id) {
      axios.get(this.crmApiPath + 'order/position_rate/get/' + order_job_id).then(rates => {
        this.ms_opts.existing_rates = rates.data.rates
      })
    },

    existing_rate_label({pay_amount, pay_type}) {
      return `£ ${pay_amount}` + ` ` + ` ` + ` ` + `(${pay_type})`
    },

    ms_add_new_rate(search_value) {
      this.new_rate.pay_amount = search_value
      this.add_new_rate = true;
      this.existing_rate = null;
    },
    check_rate_exists() {
      this.$nextTick(() => {
        if (this.new_rate.pay_type !== null) {
          let check = this.ms_opts.existing_rates.filter(rate => rate.pay_amount === parseFloat(this.new_rate.pay_amount) && rate.pay_type === this.new_rate.pay_type.value);
          if (check.length > 0) {
            this.popup_rate_exists(this.new_rate.pay_type.value, this.new_rate.pay_amount)
          }
        }
      });
    },
    popup_rate_exists(pay_type, pay_amount) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Rate Already Exists</div>' +
            '<div class="snotifyToast__body">' +
            'This position on this site already has a £' + pay_amount + ' (' + pay_type + ') rate' + '<br><br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Select Rate', action: (toast) => {
              this.add_new_rate = false;
              this.existing_rate = this.ms_opts.existing_rates.filter(rate => rate.pay_amount === parseFloat(this.new_rate.pay_amount) && rate.pay_type ===
                  this.new_rate.pay_type.value)[0];
              this.$snotify.remove(toast.id);
            }
          },
        ]
      });
    },

    // Calculate margin for recruitment crm / recruitment orders
    rate_calc_recruitment_margin(rate) {
      this.$nextTick(() => {
        rate.admin_fee = calculateRate(rate.pay_amount, this.crmType, this.job_title.order_type, this.job_title.recruitment_margin_perc);
      })
    },

    reloadRoute() {
      this.$router.go();
    },

    /***********************************************************************
     *  Submit
     ***********************************************************************/

    async submit_assign_worker() {
      this.saving = true;
      let temp_assignment = {
        worker_id: this.worker.id,
        company_id: this.job_title.company_id,
        order_job_id: this.job_title.order_job_id,
        position_rate_id: '',
        // Set assigned by values for creating the worker (current crm user)
        assigned_by_type: 'App\\Models\\Users\\User',
        assigned_by_id: this.$store.state.auth.me.id,
        start_date: this.$moment.utc(this.start_date).format('YYYY-MM-DD'),
        end_date: this.job_title.end_date,
        assigned: true,
        // No GANG LEADER / GANGER FUNCTIONALITY YET
        is_gang_leader: false,
        gang_leader_id: null,
        // Set log values for creating the worker (current crm user)
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }
      // if an existing rate is chosen set the position_rate_id on the assignment object
      if (this.existing_rate !== null) {
        temp_assignment.position_rate_id = this.existing_rate.id
      }
      // create new rate and set position_rate_id on the assignment object
      else {
        let position_rate = {
          order_job_id: this.job_title.order_job_id,
          rate_type: this.new_rate.type.value,
          pay_type: this.new_rate.pay_type.value,
          pay_amount: this.new_rate.pay_amount,
          admin_fee_type: this.ms_opts.existing_rates[0].admin_fee_type,
          admin_fee_amount: this.ms_opts.existing_rates[0].admin_fee_amount,
          retention_percentage: this.new_rate.retention_percentage,
          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        };
        await axios.post(this.crmApiPath + 'order/position_rate', position_rate).then(position_rate_id => {
          temp_assignment.position_rate_id = position_rate_id.data
        });
      }

        // save new assignment and create timesheet_records etc
        axios.post(this.crmApiPath + 'assignments/worker_assignments', temp_assignment).then(() => {
          // get email address for worker
          axios.get(this.crmApiPath + 'contact_info/email/worker/' + this.worker.id).then(emails => {
            // send assignment email if there is an email address for the worker
            if (emails.data.website_login !== null) {
              axios.post(this.crmApiPath + 'worker/email/all-assignments', {
                first_name: this.worker.person.first_name,
                email: emails.data.website_login.email_address,
                all_assignments: [{assignment: temp_assignment}]
              });
            }
          })

          this.$router.push({
            name: 'c_timesheet_r2_select_site_worker',
          params: {company_id: this.company_id, start_date: this.start_date, end_date: this.end_date, order_id: this.order_id, order_job_id: this.order_job_id}
          });
        });
    }
  },
  watch: {
    'new_rate.pay_type'(type) {
      if (type !== null) {
        // Price - pay type, set pay amount to 1 and disable input
        if (this.new_rate.pay_type.id === 24) {
          this.new_rate.pay_amount = 1;
          this.pay_amount_disabled = true;
        }
        // for all other pay types, enable pay_amount input
        else {
          // this.new_rate.pay_amount = '';
          this.pay_amount_disabled = false;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page_heading {
  padding-left: 1em;
  margin-bottom: 2em;
}

.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
}
#ts_assign_worker_modal {
  .multiselect__option {
    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      background: $bc_1;
      color: $white;
    }
  }

  .noResult {
    margin: -10px -30px -10px -15px;
    padding: 10px 15px;
    height: 38px;
    line-height: inherit;
    display: block;
    width: 100%;

    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      color: $white;
      background: $bc_1;
    }
  }
}
</style>
